/**
 * `/contact-us`: the contact form, the metals expert card and the plant finder
 * (`components/ContactUsPage/index.tsx`). Built for every brand. A hash naming a topic
 * (`/contact-us#quoteRequest`) preselects it in the form.
 */
import React from "react";
import { useApplication } from "@ryerson/frontend.application";
import MetaHead from "@components/Shared/model/MetaHead";
import {
	allContentfulHeaderCalls,
	getLocationsWithMetalExperts,
	HeaderPageProps,
} from "@ryerson/frontend.contentful";
import { getHeaderData } from "@components/NextLayouts/nextUtilities";
import HeaderLayout from "@components/NextLayouts/HeaderLayout";
import { YourMetalExpertsProps } from "@components/Shared/YourMetalExperts/YourMetalExperts";
import { ContactUsMetaObject } from "@content/shared/contact-us";

import { ContactUsPage } from "@components/ContactUsPage";
/**
 * At build: the header, locations and footer data, plus the Contentful locations with their
 * metals experts (`@ryerson/frontend.contentful` → `getLocationsWithMetalExperts`).
 */
export const getStaticProps = async () => {
	const { props: headerFooterProps } = await allContentfulHeaderCalls();

	return {
		props: {
			...headerFooterProps,
			locationsWithExperts: await getLocationsWithMetalExperts(),
		},
	};
};

/** The `/contact-us` page; see the file header. */
const Page: React.FC<HeaderPageProps & YourMetalExpertsProps> = (props) => {
	const {
		localization: { language },
	} = useApplication();

	const { locationsWithExperts } = props;

	return (
		<HeaderLayout {...getHeaderData(props)}>
			<MetaHead content={ContactUsMetaObject[language]} />
			<ContactUsPage locationsWithExperts={locationsWithExperts} />
		</HeaderLayout>
	);
};

export default Page;
